import React, { Component } from "react"
import zeroFill from "zero-fill"
import FileSaver from "file-saver"
import PropTypes from "prop-types"
import { last } from "lodash"
import { connect } from "react-redux"
import { scaleCanvas, processCommand, T, TYPE, CommandTypes } from "../../canvas/helpers"
import createContextWrapper from "../../canvas/context"
import * as drawingActions from "../../actions/drawings"
import * as uiActions from "../../actions/ui"

export const size = [1920, 1080]

// const slideHelper = [
//   16, // This body of work
//   74, // The system hold no imprint
//   93, // In doing so,
//   129, // The artwork begins its life
//   157, // From this  large population
//   184, // The offspring inherit
//   239, // The artist assumes god mode
//   262, // When a chromosome reaches an 'optimal' state,
//   282, // These are formed from the same translucent packaging
//   303, // They're mounted as squares
//   383, // Each artwork is assigned a unique hash
//   438, // Yet,
//   462, // The object complements
//   481, // In which way
// ]

@connect(() => ({}), { ...drawingActions, ...uiActions })
export default class Exhibition extends Component {
  static propTypes = {
    lecture: PropTypes.shape({
      slides: PropTypes.array,
      subtitles: PropTypes.array
    }).isRequired,
  }

  componentDidMount () {
    window.addEventListener("resize", this.resize)
    window.addEventListener("keydown", this.keyDownHandler)
  }

  shouldComponentUpdate () {
    return false
  }

  componentWillUnmount () {
    this.mounted = false
    window.removeEventListener("resize", this.resize)
    window.removeEventListener("keydown", this.keyDownHandler)
  }

  resetTime () {
    this.slideIndex = 0
    this.time = 0
    this.previousTime = this.time
  }

  keyDownHandler = (e) => {
    switch (e.which) {
      // case 49: // 1
      //   this.addCommand(CommandTypes.CHANGE_THICKNESS, 1)
      //   break
      //
      // case 50: // 2
      //   this.addCommand(CommandTypes.CHANGE_THICKNESS, 2)
      //   break
      //
      // case 51: // 3
      //   this.addCommand(CommandTypes.CHANGE_THICKNESS, 3)
      //   break
      //
      // case 52: // 4
      //   this.addCommand(CommandTypes.CHANGE_THICKNESS, 5)
      //   break

      case 81: // q
        this.addCommand(CommandTypes.CHANGE_COLOR, "#ffffff")
        break

      case 87: // w
        this.addCommand(CommandTypes.CHANGE_COLOR, "#a65bf3")
        break

      case 69: // e
        this.addCommand(CommandTypes.CHANGE_COLOR, "#4365ca")
        break

      case 82: // r
        this.addCommand(CommandTypes.CHANGE_COLOR, "#d13434")
        break

      case 84: // t
        this.addCommand(CommandTypes.CHANGE_COLOR, "#e95098")
        break

      case 89: // y
        this.addCommand(CommandTypes.CHANGE_COLOR, "#dad843")
        break

      case 85: // u ?
        this.addCommand(CommandTypes.CHANGE_COLOR, "#d06f2e")
        break

      case 73: // i ?
        this.addCommand(CommandTypes.CHANGE_COLOR, "#2dc9c0")
        break

      // case 40: // arrow down
      //   this.addCommand(CommandTypes.NEXT_PAGE)
      //   break

      case 83: // s
        if (!this.recording) {
          this.startRecording()
        } else {
          this.stopRecording()
        }
        break

      case 32: // space
        this.togglePausePlay()
        break

      case 80: // p
        this.addCommand(CommandTypes.MARCHING_ANTS)
        break

      default:
        console.log(e.which)
    }
  }

  startRecording () {
    this.play()
    this.recording = true
  }

  stopRecording () {
    this.addCommand(CommandTypes.NEXT_PAGE)
    // this.pause()
    this.saveSlideToFile()
    // this.recording = false
  }

  togglePausePlay () {
    this.playing = false // !this.playing
    this.recording = false
  }

  pause () {
    this.playing = false
  }

  play () {
    this.playing = true
  }

  resize = () => {
    scaleCanvas(this.foregroundCanvas, size[0], size[1])
    scaleCanvas(this.backgroundCanvas, size[0], size[1])
  }

  saveSlideToFile () {
    const { lecture: { slides } } = this.props
    const slide = last(slides)
    const blob = new Blob(
      [JSON.stringify(slide)],
      { type: "text/plain;charset=utf-8" }
    )

    const titleParts = [
      zeroFill(8, parseInt(slide[0][T], 10)),
      "-",
      zeroFill(8, parseInt(last(slide)[T], 10)),
      ".json"
    ]
    FileSaver.saveAs(blob, titleParts.join(""))
  }

  init (backgroundCanvas, foregroundCanvas) {
    if (backgroundCanvas && !this.backgroundCanvas) {
      this.backgroundCanvas = backgroundCanvas
    }

    if (foregroundCanvas && !this.foregroundCanvas) {
      this.foregroundCanvas = foregroundCanvas
    }

    if (!foregroundCanvas || !backgroundCanvas) return

    this.mounted = true
    this.playing = true
    this.pointerDown = false
    this.recording = false
    this.lineDashOffset = 0

    this.foregroundContext = createContextWrapper(this.foregroundCanvas)
    this.backgroundContext = createContextWrapper(this.backgroundCanvas)

    this.resize()
    this.initTimer()

    this.update()

    const durationSubtitles = last(this.props.lecture.subtitles).end
    const lastSlide = last(this.props.lecture.slides)
    const durationDrawings = lastSlide.length > 0
      ? last(lastSlide)[T] / 1000
      : 0

    this.totalDuration = Math.max(durationSubtitles, durationDrawings * 2)
  }

  initTimer () {
    const timerInterval = 1000 / 60
    this.resetTime()
    setInterval(() => this.updateTimer(timerInterval), timerInterval)
  }

  updateTimer () {
    const now = new Date().getTime()
    if (this.previousTime && this.playing) {
      this.time += (now - this.previousTime) / 2
    }
    this.previousTime = now

    if (this.time > this.totalDuration * 1000 / 2) {
      this.resetTime()
    }
  }

  updateStatus () {
    if (!this.statusContainer) return
    const statusString =
      this.recording ? "☻" : this.playing ? "►" : "◙" // eslint-disable-line

    const time = this.time / 1000 << 0
    this.statusContainer.innerHTML = `${statusString} ${time}`
  }

  currentSlide = () => this.props.lecture.slides[this.slideIndex]

  startLine = () => {
    this.pointerDown = true
  }

  endLine = () => {
    this.pointerDown = false
  }

  lastIndex () {
    const slide = this.currentSlide()
    if (slide.length === 0) return null
    let i
    for (i = 0; this.stillGoing(i); i++) {} // eslint-disable-line
    return i
  }

  drawLines (context, options, lastIndex) {
    const slide = this.currentSlide()
    for (let i = 0; i < lastIndex; i++) {
      const command = slide[i]
      this.foregroundContext.lineDashOffset(16 - this.lineDashOffset)
      processCommand(context, command, options)
    }

    this.lineDashOffset += 0.5
    this.lineDashOffset %= 16
    context.stroke()
  }

  stillGoing = (i) => {
    const slide = this.currentSlide()
    // if (i > slide.length) return false
    if (i >= slide.length - 1) return false

    return slide[i][T] < this.time
  }

  addCommand (type, ...args) {
    if (!this.playing || !this.recording) return
    const slide = this.currentSlide()
    slide.push([type, this.time, ...args])
  }

  addSegment (x, y, pressure) {
    if (this.pointerDown) {
      this.addCommand(CommandTypes.LINE_TO, x, y, pressure)
    } else {
      this.addCommand(CommandTypes.MOVE_TO, x, y)
    }
  }

  handlePointerMove = (e) => {
    this.addSegment(
      e.clientX * window.devicePixelRatio,
      e.clientY * window.devicePixelRatio,
      e.pressure
    )
  }

  shouldShowNextSlide (untilIndex) {
    const current = this.currentSlide()

    const command = current[untilIndex]
    return command[TYPE] === CommandTypes.NEXT_PAGE && this.time > command[T]
  }

  drawSlide () {
    const untilIndex = this.lastIndex()

    if (untilIndex && this.shouldShowNextSlide(untilIndex)) {
      this.slideIndex++
      if (!this.props.lecture.slides[this.slideIndex]) {
        this.props.lecture.slides[this.slideIndex] = []
      }
      return
    }

    // if (untilIndex !== this.previousLastIndex) {
    //   this.backgroundContext.clear()
    //   this.backgroundContext.gradient()
    //   this.backgroundContext.fat(true)
    //   this.backgroundContext.setStrokeColor("rgba(0, 0, 10, 0.2)")
    //   this.drawLines(this.backgroundContext, { fat: true }, untilIndex)
    // }

    this.foregroundContext.clear()
    this.foregroundContext.fat(false)
    this.foregroundContext.setStrokeColor("white")
    this.drawLines(this.foregroundContext, { fat: false }, untilIndex)

    this.foregroundContext.drawCursor()

    this.previousLastIndex = untilIndex
  }

  update () {
    const { subtitles } = this.props.lecture

    if (this.time / 1000 > last(subtitles.end)) {
      this.resetTime()
    }

    this.drawSlide()

    if (this.mounted) {
      window.requestAnimationFrame(() => this.update())
    }
  }

  updateSubtitles () {
    const { subtitles } = this.props.lecture
    const seconds = this.time / 1000 * 2
    const current = subtitles.find(sub => sub.start < seconds && sub.end > seconds)
    const content = current ? current.content : ""

    this.subsContainer.style.display = content ? "flex" : "none"

    if (content !== this.subsContainer.innerHTML) {
      this.subsContainer.innerHTML = content
    }
  }

  updateTimeIndicator () {
    this.timeIndicator.style.width = `${2 * this.time / this.totalDuration * 100 / 1000}%`

    // const currentSlideDurationIndicator = slideHelper.findIndex(segment => this.time / 1000 < segment)
    //
    // const from = currentSlideDurationIndicator === 0 ? 0 : slideHelper[currentSlideDurationIndicator - 1]
    // const to = slideHelper[currentSlideDurationIndicator]
    // const duration = to - from
    // const relativePosition = this.time / 1000 - from
    // this.timeIndicator.style.width = `${relativePosition / duration * 100}%`
  }

  updateLowTiming = () => {
    this.updateSubtitles()
    this.updateTimeIndicator()
    this.updateStatus()
  }

  initSubtitles (element) {
    if (element && !this.subsContainer) {
      this.subsContainer = element
      setInterval(this.updateLowTiming, 100)
    }
  }

  initTimeIndicator (element) {
    if (element && !this.timeIndicator) {
      this.timeIndicator = element
    }
  }

  initStatus (element) {
    if (element && !this.statusContainer) {
      this.statusContainer = element
    }
  }

  render () {
    const noResize = window.location.hash === "#noresize"
    const style = {
      width: size[0],
      height: size[1],
    }

    if (!noResize) {
      style.transform = `scale(${1 / window.devicePixelRatio})`
      style.transformOrigin = "0 0"
    }

    return (
      <div style={style}>
        <div className="bg-panel" />
        <canvas
          style={{ display: "none" }}
          className="bg"
          ref={(bg) => { if (bg && !this.backgroundCanvas) this.init(bg, this.fg) }}
        />
        <canvas
          className="fg"
          ref={(fg) => { if (fg && !this.fg) this.init(this.backgroundCanvas, fg) }}
          onPointerDown={this.startLine}
          onPointerUp={this.endLine}
          onPointerMove={this.handlePointerMove}
          onPointerLeave={this.endLine}
        />

        <div className="subtitles-container">
          <span className="subtitles-text" ref={(el) => { this.initSubtitles(el) }} />
        </div>
        <div id="logo" />
        <div id="token-logo" />
        <div id="time-indicator" ref={(el) => { this.initTimeIndicator(el) }} />
        <div id="status" ref={(el) => { this.initStatus(el) }}>loading</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Exhibition/index.jsx